import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";

export interface IUserForgotPasswordMutationParameters {
    email: string;
}

export type IUserForgotPasswordMutationResult = void;

export const forgotPasswordMutation: IApiMutationFunction<IUserForgotPasswordMutationParameters> = ({ email }) => {
    return {
        method: "POST",
        url: "/forget-password",
        data: {
            email,
        },
    };
};

export const useUserForgotPasswordMutation = createApiMutationHook<
    IUserForgotPasswordMutationParameters,
    IUserForgotPasswordMutationResult
>(forgotPasswordMutation);
